import { RootStore } from 'bzx-common/src/stores'
import { Button } from 'bzx-common/src/ui-framework'
import { observer } from 'mobx-react'
import React from 'react'
import { Icon } from 'ui-framework'

export function AppError({ rootStore }: { rootStore: RootStore }) {
  const { appError, clearError } = rootStore
  const [detailsVisible, setDetailsVisible] = React.useState(false)

  return (
    <div className={appError === null ? 'app-error' : 'app-error--visible'}>
      {appError !== null && (
        <div className={appError.error.noError ? 'app-error--no-error' : ''}>
          <Button
            className="app-error__btn-details"
            variant="invisible"
            onClick={() => setDetailsVisible(!detailsVisible)}>
            <h3 className="app-error__title">
              <small>{appError.error.title || 'Error'}</small>
            </h3>
          </Button>
          {!appError.error.noError && detailsVisible && (
            <textarea
              className="app-error__message"
              defaultValue={appError.stackMessages}
              readOnly={true}
            />
          )}
          <Button
            variant="invisible"
            title="Close"
            className="app-error__close"
            onClick={clearError}>
            <Icon size={32} name="close" top={-3} bgPadding={3} />
          </Button>
        </div>
      )}
    </div>
  )
}

export default observer(AppError)
